import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './ApplyFlexiLoanInfoView.module.css';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    startFlexiLoanApplication: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/apply-flexi-loan/' }
        })
});

const ApplyFlexiLoanInfoView = ({
    startFlexiLoanApplication
}: ReturnType<typeof mapDispatchToProps>) => {
    return (
        <MainSectionWrapper>
            <div className={styles.flexiLoanEligibleContainer}>
                <h1>Apply for a Flexi-Loan</h1>
                <p>
                    Our short term loan is designed to give a boost to
                    businesses who are on the road for recovery or weren't
                    affected by coronavirus. However, it's unlikely that we will
                    be able to offer it to businesses whose revenues are still
                    significantly lower than they were before coronavirus.
                </p>
                <p>
                    <b>With our Flexi-Loan you can:</b>
                </p>
                <ul>
                    <li>
                        <b>Get a decision in 24 hours:</b> it takes about 10
                        minutes to apply and you should have a decision within
                        one working day.
                    </li>
                    <li>
                        <b>Borrow £1,000 - £200,000:</b>
                    </li>
                    <li>
                        <b>Repay early with no fees:</b> you can repay early and
                        we'll only charge interest on the days you had the
                        funds.
                    </li>
                </ul>
                <div className="flex flex-col items-center justify-center gap-xl min-m:flex-row">
                    <a
                        href="https://www.iwoca.co.uk/insights/coronavirus-finance-small-business/"
                        rel="noopener noreferrer"
                        target="_blank"
                        data-testid="covid-finance-small-business"
                        className="link"
                    >
                        Coronavirus support page
                    </a>
                    <Button
                        className={styles.applyFlexiLoanCTA}
                        onClick={startFlexiLoanApplication}
                        data-testid="apply-for-flexi-loan"
                    >
                        Apply for a Flexi-Loan
                    </Button>
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(ApplyFlexiLoanInfoView);
